<template>
  <div class="create">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="应用名称" class="name" required>
        <el-input
          placeholder="请输入应用名称"
          v-model="form.appName"
        ></el-input>
      </el-form-item>
      <el-form-item label="版本号" class="version" required>
        <el-input
          placeholder="请输入版本号"
          v-model="form.appVersion"
        ></el-input>
      </el-form-item>

      <el-form-item label="APK" class="name apk" required>
        <div class="dropbox">
          <span v-if="files.length === 0" class="text-center">
            请拖拽apk文件到此处，或者
            <label for="upload_id" id="label_class">上传文件</label>
            <input
              id="upload_id"
              type="file"
              @change="getFile($event)"
              accept=".apk"
            />
          </span>
        </div>
      </el-form-item>
      <el-form-item>
        <template>
          {{ form.apkUrl }}
          <div
            class="progress_class"
            :style="{ width: width }"
            v-show="width != '0%'"
          >
            {{ width == "100.0%" ? "上传完成" : `上传中 ${width}` }}
          </div>
        </template>
      </el-form-item>

      <el-form-item label="应用介绍">
        <el-input
          placeholder="请输入版本描述"
          type="textarea"
          :rows="4"
          class="textarea"
          v-model="form.applicationRecommend"
        ></el-input>
      </el-form-item>
      <el-form-item label="版本描述">
        <el-input
          placeholder="请输入版本描述"
          type="textarea"
          :rows="4"
          class="textarea"
          v-model="form.versionDesc"
        ></el-input>
      </el-form-item>
      <el-form-item label="包名" class="version" required>
        <el-input
          placeholder="请输入包名"
          v-model="form.packageName"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用图标" required>
        <template>
          <div class="app_icon">
            <div>
              <div class="up-area">
                <input
                  class="upload"
                  id="img_id"
                  @change="selectedFile($event)"
                  type="file"
                  value=""
                />
                <div class="up_icon">+</div>
                <img v-show="form.appIconUrl != ''" :src="form.appIconUrl" />
              </div>
              <p>请上传应用logo，图片大小不超过300KB。</p>
            </div>
            <div class="line"></div>
            <div class="example">
              <figcaption>参考示例</figcaption>
              <img src="@/assets/logo.png" />
            </div>
          </div>
        </template>
      </el-form-item>

      <el-form-item label="上传预览" required>
        <div class="upload_div">
          <input type="file" @change="upload_pre" />
          <el-button
            class="upload_btu"
            type="file"
            :disabled="form.previewUrl.length < 5 ? disabled : ''"
            :class="form.previewUrl.length < 5 ? 'classColor' : 'classDefault'"
            >点击上传</el-button
          >
        </div>

        <div class="imagelist">
          <div
            class="img_item"
            v-for="(item, index) in form.previewUrl"
            :key="item"
          >
            <img class="images" :src="item" />
            <img
              class="icon"
              src="@/assets/re_load.png"
              @click="reduce_image(index, item)"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { new_app, get_id } from "@/api/tool_app";
var dropbox = null;
var Bucket = "ddbes-repository-1304188286";
var Region = "ap-beijing";
var cos = new COS({
  FileParallelLimit: 5,
  ChunkParallelLimit: 5,
  ChunkMbSize: 8 * 1024 * 1024,
  getAuthorization: function (options, callback) {
    get_id()
      .then((res) => {
        var data = res.data;
        callback({
          TmpSecretId: data.credentials && data.credentials.tmpSecretId,
          TmpSecretKey: data.credentials && data.credentials.tmpSecretKey,
          XCosSecurityToken: data.credentials && data.credentials.sessionToken,
          ExpiredTime: data.expiredTime,
        });
      })
      .catch((error) => {});
  },
});
export default {
  data() {
    return {
      width: "0%",
      icon_app: "",
      img_pre: "",
      files: [],
      imgList: [],
      form: {
        apkSize: "",
        apkUrl: "",
        appName: "",
        appVersion: "",
        appIconUrl: "",
        versionDesc: "",
        packageName: "",
        applicationRecommend: "",
        previewUrl: [],
        id: "",
      },
    };
  },
  created() {
    //判断对象是否不为空
    for (let i in this.$route.params) {
      return (this.form = this.$route.params);
    }
  },
  mounted() {
    dropbox = document.querySelector(".dropbox");
    dropbox.addEventListener("dragenter", this.onDrag, false);
    dropbox.addEventListener("dragover", this.onDrag, false);
    dropbox.addEventListener("drop", this.onDrop, false);
  },
  destroyed() {
    dropbox.removeEventListener("dragenter", this.onDrag, true);
    dropbox.removeEventListener("dragover", this.onDrag, true);
    dropbox.removeEventListener("drop", this.onDrop, true);
  },
  methods: {
    //新增/编辑应用时添加删除图片
    reduce_image(index, item) {
      this.form.previewUrl.splice(index, 1);
    },
    //上传预览图片
    upload_pre(e) {
      let files = e.target.files;
      var list = [].map.call(files, function (f) {
        return {
          Bucket: Bucket,
          Region: Region,
          Key: "APPINFO/" + files[0].name,
          Body: f,
        };
      });
      let that = this;
      cos.uploadFiles({
        files: list,
        onFileFinish(err, data, options) {
          that.img_pre =
            "https://ddbes-repository-1304188286.cos.ap-beijing.myqcloud.com/" +
            options.Key;
          that.form.previewUrl.push(that.img_pre);
        },
      });
    },
    uploadFile(file) {
      var item = {
        name: file.name,
        uploadPercentage: 0,
      };
      var files = [];
      files.push(item);
      this.form.apkSize = file.size;
      var list = [].map.call(files, function (f) {
        return {
          Bucket: Bucket,
          Region: Region,
          Key: "APPINFO/" + files[0].name,
          Body: f,
        };
      });
      let that = this;
      cos.uploadFiles({
        files: list,
        onProgress(err, data, options) {
          that.width = Number(err.percent * 100).toFixed(1) + "%";
        },
        onFileFinish(err, data, options) {
          that.form.apkUrl =
            "https://ddbes-repository-1304188286.cos.ap-beijing.myqcloud.com/" +
            options.Key;
        },
      });
    },
    onDrag(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var dt = e.dataTransfer;
      for (var i = 0; i !== dt.files.length; i++) {
        this.uploadFile(dt.files[i]);
      }
    },
    //手动上传apk
    getFile(e) {
      let files = e.target.files;
      this.form.apkSize = files[0].size;
      var list = [].map.call(files, function (f) {
        return {
          Bucket: Bucket,
          Region: Region,
          Key: "APPINFO/" + files[0].name,
          Body: f,
        };
      });
      let that = this;
      cos.uploadFiles({
        files: list,
        onProgress(err, data, options) {
          that.width = Number(err.percent * 100).toFixed(1) + "%";
        },
        onFileFinish(err, data, options) {
          that.form.apkUrl =
            "https://ddbes-repository-1304188286.cos.ap-beijing.myqcloud.com/" +
            options.Key;
        },
      });
    },
    //添加/修改
    async onSubmit() {
      let _data = {
        apkSize: this.form.apkSize,
        apkUrl: this.form.apkUrl,
        appIconUrl: this.form.appIconUrl,
        appName: this.form.appName,
        appRelease: JSON.parse(localStorage.getItem("loginData")).name,
        appVersion: this.form.appVersion,
        packageName: this.form.packageName,
        applicationRecommend: this.form.applicationRecommend,
        previewUrl: this.form.previewUrl,
        versionDesc: this.form.versionDesc,
      };
      if (Object.keys(this.$route.params).length != 0) {
        _data.id = this.form.id;
      }
      //判断是否有apk
      if (
        this.form.apkUrl == "" ||
        this.form.appName == "" ||
        this.form.appVersion == "" ||
        this.form.packageName == "" ||
        this.form.previewUrl == "" ||
        this.form.appIconUrl == ""
      ) {
        this.$message({
          message: "请检查必填项是否填写完全",
          type: "warning",
        });
      } else {
        let res = await new_app(_data);
        this.$message({
          message: res.data,
          type: "success",
        });
        this.$router.push({ path: "/tools_app" });
        this.$store.state.texts_status = -1;
      }
    },
    //上传应用icon
    selectedFile(e) {
      let files = e.target.files;
      if (files[0].size < 307200) {
        var list = [].map.call(files, function (f) {
          return {
            Bucket: Bucket,
            Region: Region,
            Key: "APPINFO/" + files[0].name,
            Body: f,
          };
        });
        let that = this;
        cos.uploadFiles({
          files: list,
          onFileFinish(err, data, options) {
            that.icon_app =
              "https://ddbes-repository-1304188286.cos.ap-beijing.myqcloud.com/" +
              options.Key;
            that.form.appIconUrl = that.icon_app;
          },
        });
      } else {
        this.$message.error("上传图片大小已超出300Kb");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.apk {
  position: relative;
}
.dropbox {
  border: 1px solid $border;
  min-height: 5px;
  @include s-c-w(14, $menu-text, 500);
  padding-left: 15px;
  label {
    color: $tab;
  }
  input {
    display: none;
    height: 100%;
  }
}
.create {
  .progress_class {
    // transform: scale(0.7);
     font-size:9px; 
    color: #fff;
    background-color: salmon;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 10px;
    background-image: linear-gradient(to right, #00c5ff, #2681ff);
  }
  p {
    @include s-c-w(14, $c9a, 500);
  }
  /deep/.el-form {
    .el-form-item__label {
      width: 100px !important;
      @include s-c-w(14, $c15, 500);
      text-align: left;
    }
    .el-form-item__content {
      margin-left: 100px !important;
    }
  }
  /deep/.el-button {
    padding: 8px 26px;
  }
  /deep/.el-button--primary {
    background-color: $tab;
  }
  /deep/.el-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  background-color: #fff;
  flex: 1;
  overflow: auto;
  form {
    padding: 36px 57px;
    .upload_div {
      position: relative;
      input {
        opacity: 0;
        position: absolute;
        top: 0;
        height: 100%;
        width: 110px;
      }
    }
    .name {
      width: 482px;
    }
    .version {
      width: 311px;
    }
    .textarea {
      width: 580px;
    }
    .app_icon {
      display: flex;
      .up-area {
        border: 1px dashed $border_e;
        width: 62px;
        height: 62px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        input {
          border: 0px solid black !important;
        }
        .upload {
          position: absolute;
          top: 0;
          width: 62px;
          height: 62px;
          opacity: 0;
          z-index: 10;
          /deep/.el-input__inner {
            opacity: 0;
            height: 100%;
          }
        }
        .up_icon {
          font-size: 40px;
          font-weight: 10;
          color: #e2e2e2;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .line {
        margin: 0px 67px 0px 166px;
        width: 2px;
        height: 93px;
        background-color: $border;
      }
    }
    .upload_btu {
      border-radius: 23px;
      border: 1px solid $menu-child;
      color: $menu-child;
    }
    .classColor {
      border: 1px solid $menu-child;
      color: $menu-child;
    }
    .classDefault {
      border: 1px solid $border !important;
      color: $border !important;
    }
    .imagelist {
      margin-top: 20px;
      display: flex;
      .img_item {
        margin-right: 10px;
        width: 90px;
        height: 160px;
        position: relative;
        .images {
          width: 90px;
          height: 160px;
        }
        .icon {
          position: absolute;
          right: -8px;
          top: -8px;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>